import { z } from "zod";
import { UserSchema } from "../user/UserSchema";
import { Contact } from "lucide-react";


export const TextVariableSchema = z.object({
  string_key: z.string().optional(),
  name: z.string().optional(),
  de: z.string().optional().nullable(),
  en: z.string().optional().nullable(),
  fr: z.string().optional().nullable(),
  es: z.string().optional().nullable(),
  pt: z.string().optional().nullable(),
  cz: z.string().optional().nullable(),
  zh: z.string().optional().nullable(),
});



 export const PresenterConnPropertiesSchema = z.object({
  id: z.number().optional(),
  presenter_conn_id: z.number().optional(),
  prop_id: z.number().optional(),
  prop_value: z.string().optional(),
  prop_name: z.string().optional(),
  prop_type: z.string().optional(),
  tom: z.coerce.date().optional().nullable(),

 });


    export const PresenterConnectionSchema = z.object({
        Id: z.number().optional(),
        PresenterId: z.string().optional(),
        ConnTypeId: z.number().optional(),
        section_id: z.number().optional(),
        active: z.boolean().default(false),
        TOM: z.coerce.date().optional().nullable(),

        PresenterConnProperties: z.array(PresenterConnPropertiesSchema).optional().nullable(),
    });


export const PresenterSchema  = z.object({
  Id: z.string().uuid().optional(),
  EventNr: z.string().optional().nullable(),
  PlenumId: z.number().optional(),
  UserId: z.string().optional(),
  Deleted: z.boolean().default(false),
  IsGuest: z.boolean().default(false),
  ShowLinkInAgenda: z.boolean().default(false),
  TOC: z.coerce.date().optional().nullable(),
  TOM: z.coerce.date().optional().nullable(),
  
PresenterConnections: z.array(PresenterConnectionSchema).optional(),
SelectedModuleId:z.number().optional(),
SelectedClickerId:z.number().optional(),
MobileClickerLink: z.string().optional().nullable(),

 
});

export const PresenterUserSchema = z.object({
  UserId: z.string().optional(),
  ContactEmail: z.string().optional().nullable(),
  SortOrder: z.number().optional().nullable(),
  Title_Key: z.string().optional(),
  Description_Key: z.string().optional(),
  PicturePath: z.string().optional().nullable(),
});
   

export const PresenterMainSchema = z.object({
  UserId: z.string().optional(),
  UserInfo:  PresenterUserSchema.optional(),
  Plenums: z.array(z.number()).optional(),
  PlenumsAsString: z.string().optional(),
  PresenterSettings: z.array(PresenterSchema).optional(),
  InfoTexts: z.array(TextVariableSchema).optional(),
});
 

